import TopBackground from '../../../../img/bg-matiere-active-top.webp';
import BottomBackground from '../../../../img/bg-matiere-active-bottom.webp';

const BackgroundSection = ({ backgroundSource = null, showBottomBg = true, isDetailPage = false }) => {
  const backgroundimg = backgroundSource || TopBackground;
  return (
    <>
      <div
        className="absolute top-0 left-0 w-full overflow-hidden z-1"
        style={{ height: '600px' }}
      >
        <div className="relative w-full h-full">
          <img
            src={backgroundimg}
            className="w-full h-full object-cover"
            alt="Top Background"
          />
          <div className={`absolute inset-0 ${isDetailPage ? 'fade-top' : 'fade-top-white'}`}></div>
        </div>
      </div>

      {showBottomBg && (
      <div
        className="absolute bottom-0 left-0 w-full overflow-hidden z-1"
        style={{ height: '610px' }}
      >
        <div className="relative w-full h-full">
          <img
            src={BottomBackground}
            className="w-full h-full object-cover"
            alt="Bottom Background"
          />
          <div className="absolute inset-0 fade-bottom"></div>
        </div>
      </div>
      )}
    </>
  );
};

export default BackgroundSection;
